import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const requestResetPassword = async (data = {}, params = {}) => request({
  path: "/request-reset-password",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
